import { render, staticRenderFns } from "./gradeEdit.vue?vue&type=template&id=5d781194&scoped=true&"
import script from "./gradeEdit.vue?vue&type=script&lang=js&"
export * from "./gradeEdit.vue?vue&type=script&lang=js&"
import style0 from "./gradeEdit.vue?vue&type=style&index=0&id=5d781194&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d781194",
  null
  
)

export default component.exports